import request from '@/utils/request'

const serviceApi = {
    getTime: '/home/updateTime',
    getCategory: '/home/categories',
    getList: '/home/enterprises',
    getFile: '/home/file',
    statistics: '/home/statisticsInsert'
}

export function getTime(parameter) {
    return request({
        url: serviceApi.getTime,
        method: 'get',
        params: parameter
    })
}

export function getCategory(parameter) {
    return request({
        url: serviceApi.getCategory,
        method: 'get',
        params: parameter
    })
}

export function getList(parameter) {
    return request({
        url: serviceApi.getList,
        method: 'get',
        params: parameter
    })
}

export function getFile(parameter) {
    return request({
        url: serviceApi.getFile,
        method: 'get',
        params: parameter
    })
}

/* 参数 categoryId
-3 代表访问打开次数
-2 代表搜索次数
-1 代表全部企业
1 超市商贸
2 电商平台
3 主副食品
4 餐饮企业
5 零售药品流通
6 物流及总部
7 外资企业 */
export function statistics(parameter) {
    return request({
        url: serviceApi.statistics,
        method: 'post',
        data: parameter
    })
}